import { AdvancedSearchEntityType, BridgeEntityResult } from "generated/graphql";

export const availableEntityTypes = (
    entityTypes: AdvancedSearchEntityType[],
    entities: Pick<BridgeEntityResult, "name">[],
): AdvancedSearchEntityType[] =>
    entityTypes.filter(entityType => entities.some(e => e.name === entityType));

export const resolveSelectedEntityType = (
    available: AdvancedSearchEntityType[],
    preferred: AdvancedSearchEntityType | null,
): AdvancedSearchEntityType | null =>
    available.find(entityType => entityType === preferred) ?? available[0] ?? null;
